import { ProjectPaymentDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectPaymentService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getProjectPayment(): Observable<ProjectPaymentDto[]> {
    return this.http.get<ProjectPaymentDto[]>(this.url + 'project-payment');
  }

  createProjectPayment(
    data: ProjectPaymentDto[]
  ): Observable<ProjectPaymentDto[]> {
    return this.http.post<ProjectPaymentDto[]>(
      this.url + 'project-payment',
      data
    );
  }
  getSingleProjectPayment(id: string): Observable<any> {
    return this.http.get(this.url + 'project-payment/' + id);
  }

  updateProjectPayment(
    data: ProjectPaymentDto[]
  ): Observable<ProjectPaymentDto[]> {
    return this.http.post<ProjectPaymentDto[]>(
      this.url + 'project-payment/update',
      data
    );
  }

  deleteProjectPayment(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('project-payment', ids.join(', '));
    return this.http.delete(this.url + 'project-payment', httpOptions);
  }
}
